import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SplashScreen from './SplashScreen';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';

function AppWithSplash() {
  // Only show splash when opening the home page directly.
  const shouldShowSplash =
    typeof window !== "undefined" &&
    (window.location.pathname === "/" || window.location.pathname === "");
  const [showSplash, setShowSplash] = useState(shouldShowSplash);
  if (showSplash) {
    return <SplashScreen onComplete={() => setShowSplash(false)} durationMs={4000} />;
  }
  return (
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  );
}

// Suppress React error overlay for CORS "Script error" when accessing via IP
if (process.env.NODE_ENV === 'development') {
  // Check if we're accessing via IP (not localhost)
  const isIPAccess = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
  
  if (isIPAccess) {
    // Suppress the error overlay for cross-origin script errors
    window.addEventListener('error', (event) => {
      if (event.message === 'Script error.' || event.message === '') {
        event.stopImmediatePropagation();
        console.warn('⚠️ Cross-origin script error (CORS) suppressed - This is harmless when accessing via IP address.');
        return true;
      }
    }, true); // Use capture phase to intercept early
    
    // Also suppress via onerror
    const originalError = window.onerror;
    window.onerror = function(message, source, lineno, colno, error) {
      if (message === 'Script error.' || message === '') {
        return true; // Suppress
      }
      if (originalError) {
        return originalError.call(this, message, source, lineno, colno, error);
      }
      return false;
    };
  }
}

// Global error handler for uncaught errors (non-cross-origin)
window.addEventListener('error', (event) => {
  if (event.message !== 'Script error.' && event.message !== '') {
    console.error('Global error:', {
      error: event.error,
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    });
  }
});

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithSplash />
  </React.StrictMode>
);

reportWebVitals();
